import { render } from "./my_list.vue?vue&type=template&id=5e2f7182&scoped=true"
import script from "./my_list.vue?vue&type=script&lang=js"
export * from "./my_list.vue?vue&type=script&lang=js"

import "./my_list.vue?vue&type=style&index=0&id=5e2f7182&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2f7182"]])

export default __exports__